import { BodyS } from 'components/Typography/Typography';
import CustomLink from 'components/CustomLink/CustomLink';
import { translate } from 'components/Translation';
import React, { useMemo } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/accordionContentStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import classNames from 'classnames';
import TermsAndConditionsTooltip from 'components/CustomTooltip/TermsAndConditionsTooltip';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ITermsAndConditionsProps {
	termsAndConditions: types.services.termsAndConditions;
	withoutBorder?: boolean;
}

const TermsAndConditions = ({ termsAndConditions, withoutBorder }: ITermsAndConditionsProps) => {
	const classes = useStyles();

	const termsAndConditionsClasses = classNames(classes.singleAccordionRow, classes.termsWrapper, {
		[classes.withoutBorder]: !!withoutBorder,
		[classes.additionalMargin]: termsAndConditions.type === 'link' && termsAndConditions.text,
	});

	const url = termsAndConditions.type === 'link' ? termsAndConditions.url : '';

	const content = termsAndConditions.type === 'tooltip' ? termsAndConditions.content : null;

	const text: React.ReactElement | null = useMemo(() => {
		if (termsAndConditions.type === 'link' && termsAndConditions.text) {
			if (Array.isArray(termsAndConditions.text)) {
				return (
					<>
						{termsAndConditions.text.map((text, index) => (
							<BodyS disableMargin key={index}>
								{text}
							</BodyS>
						))}
					</>
				);
			} else {
				return <BodyS disableMargin>{termsAndConditions.text}</BodyS>;
			}
		}
		return null;
	}, [termsAndConditions]);

	return (
		<div className={termsAndConditionsClasses}>
			<ConditionalRender
				show={termsAndConditions.type === 'link'}
				onTrue={() => (
					<div>
						{text}
						<CustomLink to={url} color="brand" type="bodySBold" target="_blank">
							{translate('number.services.terms.conditions')}
						</CustomLink>
					</div>
				)}
			/>
			<ConditionalRender
				show={termsAndConditions.type === 'tooltip'}
				onTrue={() => (
					<div>
						<TermsAndConditionsTooltip placement="right">{content}</TermsAndConditionsTooltip>
					</div>
				)}
			/>
		</div>
	);
};

export default TermsAndConditions;
